module.exports = __webpack_public_path__ + "img/planet-ringed.aa7218bb.svg";